import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

interface PasswordValidationProps {
  password: string;
}

export interface PasswordValidationRules {
  minLength: boolean;
  hasNumeric: boolean;
  hasSpecialChar: boolean;
  hasLowerCase: boolean;
  hasUpperCase: boolean;
}

export const validatePassword = (password: string): PasswordValidationRules => {
  return {
    minLength: password.length >= 12,
    hasNumeric: /[0-9]/.test(password),
    hasSpecialChar: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password),
    hasLowerCase: /[a-z]/.test(password),
    hasUpperCase: /[A-Z]/.test(password),
  };
};

export const isPasswordValid = (password: string): boolean => {
  const validation = validatePassword(password);
  return Object.values(validation).every((rule) => rule === true);
};

const PasswordValidation: React.FC<PasswordValidationProps> = ({
  password,
}) => {
  const validation = validatePassword(password);

  const renderRule = (isValid: boolean, text: string) => (
    <div className={`password-rule ${isValid ? 'valid' : 'invalid'}`}>
      <span className='rule-icon'>
        {isValid ? (
          <FontAwesomeIcon icon='check' />
        ) : (
          <FontAwesomeIcon icon='times' />
        )}
      </span>
      <span className='rule-text'>{text}</span>
    </div>
  );

  return (
    <div className='password-validation-container'>
      <div className='password-validation-title'>Password Requirements:</div>
      {renderRule(validation.minLength, 'Minimum length of 12 characters')}
      {renderRule(validation.hasLowerCase, 'At least one lowercase letter')}
      {renderRule(validation.hasUpperCase, 'At least one uppercase letter')}
      {renderRule(
        validation.hasNumeric,
        'At least one numeric character (0-9)',
      )}
      {renderRule(validation.hasSpecialChar, 'At least one special character')}
    </div>
  );
};

export default PasswordValidation;
